import { render } from "./CashCollectionDashboard.vue?vue&type=template&id=545f9670&scoped=true"
import script from "./CashCollectionDashboard.vue?vue&type=script&lang=js"
export * from "./CashCollectionDashboard.vue?vue&type=script&lang=js"

import "./CashCollectionDashboard.vue?vue&type=style&index=0&id=545f9670&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545f9670"]])

export default __exports__